import { render, staticRenderFns } from "./CorpPicker.vue?vue&type=template&id=36fb0a5c&"
import script from "./CorpPicker.vue?vue&type=script&lang=ts&"
export * from "./CorpPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports